import { Controller } from 'stimulus'

/**
 * Handles Apple Sign In by redirecting to Apple's OAuth authorize endpoint.
 *
 * We bypass Apple's JS SDK entirely because it is incompatible with Turbo:
 * - renderButton() only scans the DOM once (misses Turbo frame content)
 * - signIn() creates a hidden form POST that Turbo intercepts and silently drops
 */
export default class AppleSigninController extends Controller {
  static values = {
    clientId: String,
    redirectUri: String,
    state: String,
  }

  declare clientIdValue: string
  declare redirectUriValue: string
  declare stateValue: string

  signIn() {
    const params = new URLSearchParams({
      client_id: this.clientIdValue,
      redirect_uri: this.redirectUriValue,
      state: this.stateValue,
      scope: 'name email',
      response_type: 'code id_token',
      response_mode: 'form_post',
    })

    window.location.href = `https://appleid.apple.com/auth/authorize?${params}`
  }
}
